export const locale = {
  lang: "it",
  data: {
    START_BARGAINING_INSTRUCTION: "Seleziona una richiesta e scegli il candidato con cui avviare una contrattazione.",
  },
};
